import { TEDCustomNumberParser } from './TEDCustomNumberParser';
import { TEDParseNumberMode } from '../FormatterTypes';

export class TEDParseInt64 extends TEDCustomNumberParser {
  public static getInstance(): TEDParseInt64 {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseInt64;

  mode(): TEDParseNumberMode {
    return TEDParseNumberMode.pnmInt64;
  }
}
